import { Link } from "react-router-dom";
import { Button } from "../components/ui/Button";
import { Icon } from "../app/Icon";

export function NotFound() {
  return (
    <div className="mx-auto grid min-h-[50vh] w-full max-w-md place-content-center justify-items-center gap-4 text-center">
      <span className="grid h-16 w-16 place-items-center rounded-2xl bg-accent/15 font-display text-3xl font-black text-accent-strong">404</span>
      <h1 className="font-display text-2xl font-black tracking-tight">Page not found</h1>
      <p className="text-sm text-muted">This page doesn't exist or may have moved. Let's get you back on the road.</p>
      <div className="flex flex-wrap items-center justify-center gap-2">
        <Link to="/"><Button><span className="flex items-center gap-1.5"><Icon name="dashboard" className="h-4 w-4" /> Go to dashboard</span></Button></Link>
        <Link to="/jobs"><Button variant="ghost">Browse jobs</Button></Link>
      </div>
    </div>
  );
}
